// externals
import { connect } from 'react-redux';

// selectors
import * as tradeInSelectors from '../../../store/mmd/tradeIn';

// actions
import * as tradeInActionCreators from '../../../store/actionCreators';

// consts/enums
import * as tradeInRoutes from '../../../utils/routes';
import { processStepperRoutes } from '../../../utils/tradeInDecisionLogic';
import { LOAN_BALANCE_OPTION_TYPES, LOAN_BALANCE_TRADE_IN_STEP, STEPPER_ROUTES, stepperRouteMap } from '../../../utils/constants';
import { isShowroomExperience } from '../../../utils/configUtils';

// components

// interfaces/types
import { IEstimateLoanBalanceUIDispatchProps, IEstimateLoanBalanceUIStateProps } from './EstimateLoanBalanceInterfaces';
import { IRootProps } from '../../../components/RootProps';
import { StepperRoute } from '../../../types';
import EstimateLoanBalanceUI from './EstimateLoanBalanceUI';

const mapStateToProps = (state: any, ownProps: IRootProps): IEstimateLoanBalanceUIStateProps => {
    const { tradeIn } = tradeInSelectors.getTradeInState(state, ownProps.tradeIndex);
    const isAmdLienPayoffQuoteSpOnSPEnabled = tradeInSelectors.isAmdLienPayoffQuoteEnabled(state);
    const { vehicle } = tradeIn;

    const vehicleName = `${vehicle.year} ${vehicle.make.name} ${vehicle.model.name}`;
    const amountOwed = tradeInSelectors.getTradeInAmountOwed(tradeIn);

    const pageTitle = 'Trade-In Vehicle';
    const pageSubTitle = 'Determine how much your current vehicle, is worth, and apply that value to your new vehicle.';

    const isSalesView = isShowroomExperience(ownProps.config);
    const tradeInSource = tradeIn?.source;
    const selectedStepperRoute: StepperRoute[] = stepperRouteMap[tradeInSource] || STEPPER_ROUTES.loanBalance;
    const selectedLoanBalanceOption = tradeInSelectors.getTradeInSelectedLoanBalanceOption(tradeIn);
    const stepperRoutes = processStepperRoutes(
        state,
        selectedStepperRoute,
        isSalesView,
        isAmdLienPayoffQuoteSpOnSPEnabled,
        ownProps.tradeIndex,
        LOAN_BALANCE_TRADE_IN_STEP,
        tradeInRoutes.TRADE_ESTIMATE_LOAN_BALANCE
    );

    return {
        vehicle,
        vehicleName,
        pageTitle,
        pageSubTitle,
        stepperRoutes,
        tradeInSource,
        amountOwed,
        selectedLoanBalanceOption,
        tradeIndex: ownProps.tradeIndex,
        urlPath: ownProps.tradeInRoute
    };
};

const mapDispatchToProps = (dispatch: any): IEstimateLoanBalanceUIDispatchProps => {
    return {
        dispatchAnalytics: (type: string, description: string) => {
            dispatch(tradeInActionCreators.dispatchAnalytics(type, description));
        },
        goToRoute: (route: string) => {
            dispatch(tradeInActionCreators.updateTradeInCurrentLocation(route));
        },
        next: () => {
            dispatch(tradeInActionCreators.cdlEstimateLoanBalanceContinueButtonClicked());
            dispatch(tradeInActionCreators.updateTradeInCurrentLocation(tradeInRoutes.TRADE_LOAN_CONFIRMATION));
        },
        goBack: (selectedLoanBalanceOption) => {
            const backRoute =
                selectedLoanBalanceOption === LOAN_BALANCE_OPTION_TYPES.LOAN_ESTIMATE
                    ? tradeInRoutes.TRADE_LOAN_BALANCE_OPTIONS
                    : tradeInRoutes.TRADE_REGISTRATION_DETAILS;
            dispatch(tradeInActionCreators.updateTradeInCurrentLocation(backRoute));
        },
        removeTrade: () => {
            // fire CDL analytics for cancel, then remove trade and route to the trade-in start
            dispatch(tradeInActionCreators.cdlCancelTradeInButtonClicked(LOAN_BALANCE_TRADE_IN_STEP));
            dispatch(tradeInActionCreators.updateTradeInCurrentLocation(tradeInRoutes.TRADE_IN));
            dispatch(tradeInActionCreators.removeTradeIn());
        },
        cdlBackButtonClicked: () => {
            dispatch(tradeInActionCreators.cdlBackButtonClicked(LOAN_BALANCE_TRADE_IN_STEP));
        },
        cdlCancelTradeInButtonClicked: () => {
            dispatch(tradeInActionCreators.cdlCancelTradeInButtonClicked(LOAN_BALANCE_TRADE_IN_STEP));
        },
        onInputValueChange: (val: string) => {
            const amountOwed = parseInt(val.replace(/[^0-9]+/g, ''));
            dispatch(tradeInActionCreators.updateTradeInBalanceOwed(amountOwed));
            dispatch(tradeInActionCreators.updateTradeInLenderName('--'));
        }
    };
};

const Estimated = connect(mapStateToProps, mapDispatchToProps)(EstimateLoanBalanceUI);

export default Estimated;
